import * as rudderanalytics from 'rudder-sdk-js';

rudderanalytics.load(
  '1g5yIBSEUl8aOC3ORKfOL76id3V',
  'https://events-api.appmaker.xyz/'
);

export default rudderanalytics;
